// extracted by mini-css-extract-plugin
var _1 = "CommentCreate-module__actions--yGiEY";
var _2 = "CommentCreate-module__animatedBackground--emn1f";
var _3 = "CommentCreate-module__avatar--uULXP";
var _4 = "CommentCreate-module__container--ciRXH";
var _5 = "CommentCreate-module__editor--Bm1B_";
var _6 = "CommentCreate-module__newThread--zWmbr";
export { _1 as "actions", _2 as "animatedBackground", _3 as "avatar", _4 as "container", _5 as "editor", _6 as "newThread" }
